/**
 * How many entries this business has saved (GET /orgs/:orgId/entries, the same list Activity reads), from a day on, for the plan
 * moments (core paywall.ts VALUE_WORDS): the trial's last days and the lock screen. Null until known, or when it can't be read: the
 * screens then say what they said before. Never a reason to block anything.
 */
import { useEffect, useState } from "react";
import { useApi } from "../session.tsx";

export function useSavedCount(orgId: string, from: string | null | undefined, on = true): number | null {
  const api = useApi();
  const [n, setN] = useState<number | null>(null);
  useEffect(() => {
    if (!on) { setN(null); return; }
    let live = true;
    api.entries(orgId, from ? { from } : {}).then((rows) => { if (live) setN(rows.length); }, () => { if (live) setN(null); });
    return () => { live = false; };
  }, [api, orgId, from, on]);
  return n;
}
